import { Sonner, sonner } from 'twyne-new.ui';

import { useTheme } from '../Theme';
const handleSuccess = (title = 'Success', description, action) => sonner.success(title, { description, action })
const handleWarning = (title = 'Warning', description, action) => sonner.warning(title, { description, action })
const handleError = (title = 'Error', description, action) => sonner.error(title, { description, action })
function useAppAlert() {
  return {
    handleSuccess,
    handleWarning,
    handleError,
  }
}

const AppAlertProvider = ({ children }) => {
  const theme = useTheme()
  return <>
    <Sonner position='top-right' richColors closeButton theme={theme} />
    {children}
  </>
}

export {
  useAppAlert,
  AppAlertProvider,
}
